import React from "react";
import { graphql } from "gatsby";
import Layout from "../components/App/Layout";
import SEO from "../components/App/SEO";
import PageBanner from "../components/Common/PageBanner";
import IndustryList from "../components/Industry/IndustryList";
import Sidebar from "../components/Industry/Sidebar";
import { removeMarkdownFormatting } from "../libs/utils";

const TagIndustries = props => {
  const { data, pageContext } = props;
  const industries = data.industries.nodes;
  const tag = data.tag;
  const { totalIndustryPages, limit, skip, tagId } = pageContext;
  const { name: tagName, title: tagTtile, description: tagDesc, keywords } = tag || {};
  const firstIndustry = industries[0];
  const { title: firstTitle = "", content: firstContent = "" } = firstIndustry || {};
  const plainText = removeMarkdownFormatting(firstContent);
  // console.log("tagId", tagId);

  return (
    <Layout stickyHeader>
      <SEO title={tagTtile || `${firstTitle}-大任软件新闻`} description={tagDesc || plainText.substring(0, 140)} keywords={keywords || tagName} />

      <PageBanner
        pageTitle={<>行业资讯新闻</>}
        breadcrumbs={[
          { text: "首页", url: "/" },
          { text: "行业资讯新闻", url: "/industryInfo/all/page_1" },
        ]}
        activePageText={tagName}
      />
      <section className="blog-details-area ptb-100">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-md-12">
              <IndustryList baseUrl={`/industryInfo/tag_${tagId}`} industries={industries} totalPage={totalIndustryPages} curPage={skip / limit + 1} />
            </div>
            <div className="col-lg-4 col-md-12">
              <Sidebar />
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export const query = graphql`
  query GetTagIndustries($tagId: Int, $limit: Int, $skip: Int) {
    industries: allStrapiIndustry(filter: { industry_tags: { elemMatch: { id: { eq: $tagId } } } }, limit: $limit, skip: $skip, sort: {order: DESC, fields: date}) {
      nodes {
        title
        slug
        desc
        content
        strapiId
        date
        image {
          childImageSharp {
            fixed {
              src
            }
          }
        }
      }
    }
    tag: strapiIndustryTag(strapiId: { eq: $tagId }) {
      name
      id
      strapiId
      keywords
      description
      title
    }
  }
`;

export default TagIndustries;
